<script>
import utils from "@/utils/utils";

export default {
  name: '',
  props: ['visible', 'info', 'limit'],
  data() {
    return {
      // 行业模板数据 1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗
      industryList: [{
        label: '电梯',
        value: 1,
        disabled: false
      }, {
        label: '家具',
        value: 2,
        disabled: false
      }, {
        label: '汽车',
        value: 3,
        disabled: false
      }, {
        label: '物业',
        value: 4,
        disabled: false
      }, {
        label: '照明',
        value: 5,
        disabled: false
      }, {
        label: '空调',
        value: 6,
        disabled: false
      }, {
        label: '服务器',
        value: 7,
        disabled: false
      }, {
        label: '视频会议',
        value: 8,
        disabled: false
      }, {
        label: '体育',
        value: 9,
        disabled: false
      }, {
        label: '医疗',
        value: 10,
        disabled: false
      }],
      industryType: 0
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 导出
    async exportMore() {
      // 数据超过1000条，不能导出
      if (this.limit === 10000) {
        this.$message({
          type: 'warning',
          message: '单次最多支持导出10000条数据'
        });
        return
      }
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      let res
      try {
        if (this.industryType === 0) {
          res = await this.$request.exportTableTenderingMessage({
            ...this.info,
            exportType: 2
          })
        } else {
          res = await this.$request.exportDataStatistics({
            ...this.info,
            industryType: this.industryType
          })
        }
      } catch (err) {
        this.requestFail(err);
      }
      if (res.status) {
        loading.close();
        this.requestError(res.status, res.message);
      } else if (res) {
        loading.close();
        let date = new Date();
        const fileName = `中标标讯数据导出-${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`
        let blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=UTF-8' });
        utils.saveAs(blob, `${fileName}`)
      }
    },
  }
}
</script>

<template>
  <div>
    <el-dialog :before-close="handleClose" :visible.sync="visible" title="选择数据导出模板" width="660px">
      <el-radio-group v-model="industryType" size="small">
        <div>
          <el-divider content-position="left">全字段数据导出</el-divider>
          <el-radio :label="0" border>原始数据</el-radio>
          <div style="height: 20px;"></div>
          <el-divider content-position="left">行业模板数据导出</el-divider>
          <div class="ex-radio">
            <div v-for="item in industryList" :key="item.value">
              <el-radio :label="item.value" border style="width: 100px">
                {{ item.label }}
              </el-radio>
            </div>
          </div>
        </div>
      </el-radio-group>
      <div class="ex-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="exportMore">导出数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="less" scoped>
.ex-radio {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.ex-footer {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
</style>